export {removeLinebreaks};

function removeLinebreaks(str) {
    return str.replace(/(\r\n|\n|\r)/gm, ""); // .trim()
  }